export const navItemsData = [
    { name: 'Home', page: 'home' },
    // { name: 'About Us', page: 'about' },
    { name: 'Products', page: 'products' },
    // { name: 'Software', page: 'software' },
    { name: 'Our Clients', page: 'clients' },
    { name: 'Contact Us', page: 'contact' },
    { name: 'More', page: 'more_dropdown_placeholder' } // Placeholder for 'More' dropdown
];

export const siteInfoData = {
    tagline: `We Provide <b>The Best Service & Customer Satisfaction</b>`,
    contactPhoneNumber: "(+91) 9408028406",
    socialLinks: [
        { name: "Facebook", char: "f", url: "https://jiotronik.com/knowledge-base/#" },
        { name: "Twitter", char: "t", url: "https://jiotronik.com/knowledge-base/#" },
        { name: "Instagram", char: "i", url: "#" }, // Assuming 'i' for Instagram from the image
        { name: "LinkedIn", char: "l", url: "#" }
    ]
};